<template>
  <div class="top-nav-bar">
    <div class="nav-left">
      <div class="title">运营驾驶舱|{{ communityName }}</div>
    </div>

    <div class="nav-right">
      <div class="nav-menu">
        <a href="#" class="nav-link" :class="{ active: activeMenu === 'status' }" @click.prevent="setActiveMenu('status')">社区态势</a>
        <a href="#" class="nav-link" :class="{ active: activeMenu === 'video' }" @click.prevent="setActiveMenu('video')">视频中心</a>
        <a href="#" class="nav-link" :class="{ active: activeMenu === 'alarm' }" @click.prevent="setActiveMenu('alarm')">告警中心</a>
        <a href="#" class="nav-link" :class="{ active: activeMenu === 'health' }" @click.prevent="setActiveMenu('health')">健康生活</a>
        <a href="#" class="nav-link" :class="{ active: activeMenu === 'culture' }" @click.prevent="setActiveMenu('culture')">社区文化</a>
      </div>
      <div class="user-info">
        <span class="username">{{ username }}</span>
        <span class="datetime">{{ currentDateTime }}</span>
        <button class="fullscreen-btn" @click="toggleFullscreen" :title="isFullscreen ? '退出全屏' : '全屏'">
          <svg v-if="!isFullscreen" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 2h4v1H3v3H2V2zm8 0h4v4h-1V3h-3V2zm0 12h4v-4h-1v3h-3v1zm-8 0v-1h3v1H2v-4h1v4z" fill="currentColor"/>
          </svg>
          <svg v-else width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 3h3v1H4v2H3V3zm7 0h3v3h-1V4h-2V3zm0 10h3v-3h-1v2h-2v1zm-7 0v-2h2v1H3v1z" fill="currentColor"/>
          </svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { communityStore } from '../stores/community'
import { menuStore } from '../stores/menu'
import { getCurrentCommunity } from '@/utils/vc'
import { getUserName } from '@/api/user/userApi'

export default {
  name: 'TopNavBar',
  data() {
    return {
      communityStore,
      menuStore,
      currentDateTime: '',
      timer: null,
      communityName: '', // 社区名称，从接口获取
      username: '', // 当前登录用户名
      isFullscreen: false // 全屏状态
    }
  },
  computed: {
    activeMenu() {
      return this.menuStore.activeMenu
    }
  },
  watch: {
    'communityStore.currentCommunity'() {
      this.updateCommunityName()
    }
  },
  mounted() {
    this.updateDateTime()
    this.timer = setInterval(this.updateDateTime, 1000)
    this.updateCommunityName()
    this.updateUsername()
    // 监听全屏状态变化
    this.addFullscreenListeners()
    this.checkFullscreen()
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer)
    this.removeFullscreenListeners()
  },
  methods: {
    setActiveMenu(menu) {
      this.menuStore.setActiveMenu(menu)
    },
    updateDateTime() {
      const now = new Date()
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const day = String(now.getDate()).padStart(2, '0')
      const hours = String(now.getHours()).padStart(2, '0')
      const minutes = String(now.getMinutes()).padStart(2, '0')
      this.currentDateTime = `${year}年${month}月${day}日 ${hours}:${minutes}`
    },
    // 更新社区名称（从接口获取）
    updateCommunityName() {
      try {
        const currentCommunity = getCurrentCommunity()
        if (currentCommunity && currentCommunity.name) {
          this.communityName = currentCommunity.name
        } else if (currentCommunity && currentCommunity.communityName) {
          this.communityName = currentCommunity.communityName
        } else {
          // 如果获取不到，显示空
          this.communityName = ''
        }
      } catch (e) {
        console.warn('获取社区名称失败:', e)
        // 如果获取失败，显示空
        this.communityName = ''
      }
    },
    // 更新当前登录用户名
    updateUsername() {
      try {
        const userName = getUserName()
        if (userName) {
          this.username = userName
        } else {
          // 如果获取不到用户名，显示默认值
          this.username = '未登录'
        }
      } catch (e) {
        console.warn('获取用户名失败:', e)
        // 如果获取失败，显示默认值
        this.username = '未登录'
      }
    },
    // 切换全屏
    toggleFullscreen() {
      if (!this.isFullscreen) {
        this.enterFullscreen()
      } else {
        this.exitFullscreen()
      }
    },
    // 进入全屏
    enterFullscreen() {
      const element = document.documentElement
      if (element.requestFullscreen) {
        element.requestFullscreen()
      } else if (element.webkitRequestFullscreen) {
        // Safari
        element.webkitRequestFullscreen()
      } else if (element.mozRequestFullScreen) {
        // Firefox
        element.mozRequestFullScreen()
      } else if (element.msRequestFullscreen) {
        // IE/Edge
        element.msRequestFullscreen()
      }
    },
    // 退出全屏
    exitFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen()
      } else if (document.webkitExitFullscreen) {
        // Safari
        document.webkitExitFullscreen()
      } else if (document.mozCancelFullScreen) {
        // Firefox
        document.mozCancelFullScreen()
      } else if (document.msExitFullscreen) {
        // IE/Edge
        document.msExitFullscreen()
      }
    },
    // 检查全屏状态
    checkFullscreen() {
      this.isFullscreen = !!(
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement ||
        document.msFullscreenElement
      )
    },
    // 添加全屏监听器
    addFullscreenListeners() {
      document.addEventListener('fullscreenchange', this.handleFullscreenChange)
      document.addEventListener('webkitfullscreenchange', this.handleFullscreenChange)
      document.addEventListener('mozfullscreenchange', this.handleFullscreenChange)
      document.addEventListener('MSFullscreenChange', this.handleFullscreenChange)
    },
    // 移除全屏监听器
    removeFullscreenListeners() {
      document.removeEventListener('fullscreenchange', this.handleFullscreenChange)
      document.removeEventListener('webkitfullscreenchange', this.handleFullscreenChange)
      document.removeEventListener('mozfullscreenchange', this.handleFullscreenChange)
      document.removeEventListener('MSFullscreenChange', this.handleFullscreenChange)
    },
    // 处理全屏状态变化
    handleFullscreenChange() {
      this.checkFullscreen()
    }
  }
}
</script>

<style lang="scss" scoped>
.top-nav-bar {
  height: 70px;
  background: linear-gradient(90deg, rgba(0, 212, 255, 0.1) 0%, rgba(0, 255, 255, 0.05) 100%);
  border-bottom: 2px solid rgba(0, 212, 255, 0.3);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 30px;
  backdrop-filter: blur(10px);
}
.nav-left {
  display: flex;
  align-items: center;
  gap: 20px;
  .logo {
    font-size: 24px;
    font-weight: bold;
    color: #00d4ff;
  }
  .title {
    font-size: 20px;
    font-weight: bold;
    color: #fff;
    letter-spacing: 2px;
  }
}
.nav-right {
  display: flex;
  align-items: center;
  gap: 30px;
}
.nav-menu {
  display: flex;
  gap: 20px;
  .nav-link {
    color: #a0b3c8;
    text-decoration: none;
    font-size: 14px;
    padding: 8px 15px;
    border-radius: 4px;
    transition: all 0.3s;
    border: 1px solid transparent;
    &:hover {
      color: #00d4ff;
      background: rgba(0, 212, 255, 0.1);
    }
    &.active {
      color: #00d4ff;
      background: rgba(0, 212, 255, 0.2);
      border-bottom: 2px solid #00d4ff;
    }
    &.nav-link-more-stats {
      // 默认样式与其他按钮一致
      &:hover {
        color: #00d4ff;
        background: rgba(0, 212, 255, 0.1);
      }
      &.active {
        color: #00d4ff;
        background: rgba(0, 212, 255, 0.2);
        border-bottom: 2px solid #00d4ff;
      }
    }
  }
}
.user-info {
  display: flex;
  align-items: center;
  gap: 20px;
  .username {
    color: #00d4ff;
    font-weight: bold;
  }
  .datetime {
    color: #a0b3c8;
    font-size: 14px;
  }
}
.fullscreen-btn {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 212, 255, 0.1);
  border: 1px solid rgba(0, 212, 255, 0.3);
  border-radius: 4px;
  color: #00d4ff;
  cursor: pointer;
  transition: all 0.3s;
  padding: 0;
  &:hover {
    background: rgba(0, 212, 255, 0.2);
    border-color: rgba(0, 212, 255, 0.5);
    transform: scale(1.05);
  }
  &:active {
    transform: scale(0.95);
  }
  svg {
    display: block;
  }
}
</style>


